// Async import creates the boundary needed for shared module resolution
import('./bootstrap');
